export const campusPlacement = {
  id: 'campus-placement',
  version: 2,
  renderer: 'enterprise', name: 'Campus Placement Classic',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['student'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 45,
    visual: 15,
    executive: 10,
    student: 30
  },
  sectionOrder: ['personal-info', 'education', 'projects', 'skills', 'experience', 'extracurricular'],
  components: {
    header: 'header-classic',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-classic'
  },
  metadata: {
    industry: ['IT Services', 'Consulting Firms', 'Campus Recruiters'],
    companies: ['TCS', 'Infosys', 'Wipro', 'Cognizant', 'Capgemini', 'Accenture', 'L&T Infotech'],
    ats: ['Taleo', 'Workday', 'Lever'],
    pages: { min: 1, max: 1, preferred: 1 },
    photo: false,
    icons: false,
    density: 'high',
    columns: 1,
    experienceLevel: ['Student', 'Entry-level'],
    careerStage: 'Student',
    recommendedFor: ['Engineering Graduates', 'Computer Application Students', 'College Candidates'],
    avoidFor: ['Executives', 'Senior Professionals', 'Freelancers'],
    dna: ['Student-Centric', 'ATS-Safe', 'Education-First', 'Structured', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 96,
      scanningSpeed: 95,
      visualAppeal: 82
    },
    hiringManager: {
      firstImpression: "Highly organized, eager-to-learn fresh graduate with strong foundation credentials",
      scanningStyle: "Top-to-bottom scan looking for education details, CGPA, college projects, and core languages",
      preferredStructure: "Education, projects, experience/internships, skills, extracurricular",
      dislikes: ["Wall of text experience summaries", "Soft skill ratings list", "Graphics or icons"]
    },
    strategy: {
      goal: "Pass standard screening tests and make college credentials (CGPA, degree) immediately visible",
      focus: "Academic achievements, course projects, coding skills",
      avoid: ["Professional summary fluff", "Non-technical details"]
    },
    psychology: {
      coreTraits: ["Diligence", "Structure", "Aptitude", "Discipline"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on academic projects, lab exercises, coding hackathons, and certifications. Use standard academic language. Highlight group project leadership role if any.",
      rewriteStyle: "Structured, academic, technical"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9pt",
      lineHeight: 1.35,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['education', 'projects', 'experience', 'skills', 'extracurricular']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '20px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '1.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '18px',
    '--spacing-item-mb': '10px',
    '--spacing-bullet-gap': '4px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default campusPlacement;
